import React, {useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import styles from './unsubscription.module.css';
import {ReactComponent as UnsubscriptionLogo} from './img-unsubscription/logo.svg';
import ConditionsBlock from "../../components/ConditionsBlock/ConditionsBlock";
import RoutesToPages from "../../assets/RoutesToPages/Routes";
import Routes from "../../assets/RoutesToPages/Routes";
import ServerRequest from "../../ServerRequests/ServerRequest";
import UnsubPopup from "../../components/UnsubPopup/UnsubPopup";
import Inputmask from "inputmask";


const Unsubscription = () => {
  const navigate = useNavigate();
  const [isUnsubPopupShown, setIsUnsubPopupShown] = useState(false);
  // const [number, setNumber] = useState(localStorage.getItem('phoneNumber') ?? '+421 xxx-xxx-xxx');
  // const location = useLocation();
  // const locationPath = location.pathname;
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);
  const countryCodeRef = useRef(null);
  const pencilImgRef = useRef(null);
  const [isIncorrectNumber, setIsIncorrectNumber] = useState(false);


  useEffect(() => {
    Inputmask({
      mask: "999-999-999",
      placeholder: " ", // ← Забирає підкреслення
      showMaskOnHover: false,
      showMaskOnFocus: true,
      showMaskOnBlur: false,
    }).mask(inputRef.current);
  }, []);


  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  }


  // useEffect(() => {
  //   if ((locationPath === Routes.unsubscription) && !localStorage.getItem('phoneNumber')) {
  //     navigate(RoutesToPages.loginPage);
  //   }
  // }, [locationPath, number]);


  const handleSubmit = async () => {
    const phoneNumber = countryCodeRef.current.textContent.slice(1) + inputValue.replace(/\D/g, "");
    // console.log(phoneNumber);

    if (phoneNumber.length === 12) {
      setIsIncorrectNumber(false);

      const serverData = await ServerRequest.unsubscribeUser(phoneNumber);
      const parsedServerData = await serverData.json();
      console.log(parsedServerData);

      if (parsedServerData.status === 200) {
        navigate(RoutesToPages.unsubscriptionSuccess);
      } else {
        setIsUnsubPopupShown(true);
      }
    } else {
      setIsIncorrectNumber(true);
    }
  };


  const redirectToSpecifiedTerm = (e) => {
    if (!e.target) return;

    navigate(RoutesToPages.terms, {
      state: e.currentTarget.dataset.terms
    });
  }


  return (
    <div className={styles.container}>
      <div className={styles.containerContent}>
        <UnsubscriptionLogo className={styles.logo}
                            width='280'
                            height='188'/>
        <p className={styles.descriptionsInfo}>Tu môžete spravovať svoje predplatné.</p>
        <p className={styles.descriptionsInfo}>Vaše predplatné Avoca'DO je momentálne aktívne.</p>
        {/*<p className={styles.descriptionsInfo}>Tvoje telefónne číslo:*/}
        {/*  <span className={styles.userPhone}>{` ${number}`}</span>*/}
        {/*</p>*/}

        <div className={
          styles["input-unsubscribe-container"]}>
            <span ref={countryCodeRef}
                  className={styles['country-code']}>+421</span>
          <input
            type='tel'
            ref={inputRef}
            value={inputValue}
            onChange={handleInputChange}
            onFocus={() => setIsIncorrectNumber(false)}
            // onInput={(e) => setInputValue(e.target.value)}
            className={`${styles["input-number"]}
              ${isIncorrectNumber ? styles["invalid-number-error"] : ''}`}
            placeholder="(__)-__-__-___"
            inputMode="numeric"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
          />
          <div className={styles['edit-pencil-container']}>
            <img ref={pencilImgRef}
                 className={styles['edit-pencil-img']}
                 loading="lazy"
                 src={require('./img-unsubscription/edit-pencil.svg').default}
                 alt="pencil image"/>
          </div>
        </div>

        <button className={styles.unsubscriptionBtn}
                onClick={handleSubmit}>
          Zrušiť predplatné
        </button>
        <p className={styles.descriptionsInfo}>Naše zákaznícke služby sú tu tiež pre vás!</p>
        <p className={styles.descriptionsInfo}>Email: propulse.sk@silverlines.info</p>
        <p className={styles.descriptionsInfo}>Telefón: +421 313215999</p>
      </div>

      <div className={styles.containerFooter}>
        <ConditionsBlock handleRedirectToTerm={redirectToSpecifiedTerm}/>
        <a className={styles.home}
           onClick={() => navigate(Routes.mainPage)}>Domov</a>
      </div>

      {isUnsubPopupShown && <UnsubPopup handleShow={setIsUnsubPopupShown}
                                        isShown={isUnsubPopupShown}/>}
    </div>
  );
};

export default Unsubscription;